module.exports = __webpack_public_path__ + "static/vanguard-0e520c51f66296b14dba5c8af76fb4e3.png";